import api from "../api/api";

export const deleteMaintenance = async (id) => {
  const response = await api.delete(`/maintenance/${id}`);
  return response.data;
};

export const getMaintenance = async (status = 'pendente') => (await api.get(`/maintenance?status=${status}`)).data;

export const createMaintenance = async (data) => (await api.post("/maintenance", data)).data;

export const resolveMaintenance = async (osId, data) => (await api.put(`/maintenance/${osId}/resolve`, data)).data;

// 🆕 Busca histórico da máquina para a gaveta lateral
export const getPrinterHistory = async (printerId) => (await api.get(`/maintenance/printer/${printerId}`)).data;